// @ts-check

// @ts-ignore
import { get, set } from 'fe-lib-localstorage';

export const OPT_IN_BRAND2020 = 'OPT_IN_BRAND2020';
export const HAS_SEEN_UI_TOUR = 'HAS_SEEN_UI_TOUR';
export const HAS_SEEN_OPT_OUT_TOUR = 'HAS_SEEN_OPT_OUT_TOUR';

export const getIsBrand2020Released = () => true;

export const getIsBrand2020Forced = () => true;

export const getIsOptedIn = () => get(OPT_IN_BRAND2020) === 'true';

export const getHasOptedOut = () => get(OPT_IN_BRAND2020) === 'false';

export const getHasSeenUITour = () => get(HAS_SEEN_UI_TOUR) === 'true';

export const getHasSeenOptOutTour = () => get(HAS_SEEN_OPT_OUT_TOUR) === 'true';

export const shouldShowOptIn = () => false;

export const shouldShowOptOut = () => false;

export const shouldShowUITour = () => !getHasSeenUITour();

export const shouldShowOptOutTour = () => false;

export const doOptIn = () => {};

export const doOptOut = () => {};

export const doFinishUITour = () => {
  set(HAS_SEEN_UI_TOUR, 'true');
};

export const doFinishOptOutTour = () => {};

export const doResetOptOutTour = () => {
  set(HAS_SEEN_OPT_OUT_TOUR, 'false');
};

export const getIsBrand2020Active = () => true;

export const useBrand2020Theme = () => {};

export const useLegacyTheme = () => {};
